import { BaseEntity } from '../../base-entity';

export enum PaymentType {
  Discrete = 'discrete',
  Hourly = 'hourly',
}

export interface SettingsLecturersRateType extends BaseEntity {
  id: number;
  typeRateName: string;
  paymentType: PaymentType;
  description: string;
}

export const getPaymentTypeDisplayText = (paymentType: PaymentType) => {
  switch (paymentType) {
    case PaymentType.Discrete:
      return 'בדיד';
    case PaymentType.Hourly:
      return 'שעתי';
  }
};
